import { ClientManagementComponent } from './client-management.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        component: ClientManagementComponent,
        children: [],
    },
];

export const ClientManagementRoutes = RouterModule.forChild(routes);
